import Service from '@/service/index.js';
import getSummaries from '@/utils/mixins/transaction-get-summaries.js';

export default {
  mixins: [getSummaries],
  props: {
    previewContract: {
      type: Object,
      default: {}
    },
    massifType: {
      type: Array,
      default: []
    },
    projectSubType: {
      type: String,
      default: ''
    },
    closeBtn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: '',
      dialogFormVisible: true,
      disputeWay: [],
      citytitle: ''
    };
  },
  computed: {
    disposalRetainedForest () {
      const str = this.previewContract && this.previewContract.disposalRetainedForest;
      if (str) {
        return JSON.parse(this.previewContract.disposalRetainedForest);
      }
    },
    disposalAncillaryFacilities () {
      const str = this.previewContract && this.previewContract.disposalAncillaryFacilities;
      if (str) {
        return JSON.parse(this.previewContract.disposalAncillaryFacilities);
      }
    },
    previewPageContract () {
      if (this.previewContract && this.previewContract.assetsInfo) {
        return JSON.parse(this.previewContract.assetsInfo);
      }
    }
  },
  created () {
    const obj = {
      WOODLAND_DISPUTE_RESOLUTION_WAY: 'disputeWay'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  methods: {
    handleScroll () {
      const scrollTop = this.$refs.box.scrollTop; // 获取滑动距离
      if (scrollTop >= 1600) {
        this.$emit('enabledBtn');
      }
    },
    dialogFormClick () {
      this.$emit('dialogFormClick');
    }
  }
};
